import { rendersInCurrentWindow } from "./agent-presentation-ack";
import type {
  AgentPresentation,
  AgentPresentationStep,
} from "./agent-presentation-types";
import { isTauri } from "./is-tauri";
import { usePresentationCompletionStore } from "@/stores/presentation-completion-store";

function hasAnswer(step: AgentPresentationStep): boolean {
  if (
    step.kind !== "point" &&
    step.kind !== "highlight" &&
    step.kind !== "draw"
  )
    return false;
  if (step.bubble?.trim() || step.narration?.trim()) return true;
  return (
    step.kind !== "point" &&
    step.callout_role !== "context" &&
    Boolean(step.callout?.trim())
  );
}

/** Called only after every step has finished rendering and narration. */
export function recordPresentationCompletion(
  presentation: AgentPresentation,
): void {
  if (
    !presentation.executionId ||
    !presentation.steps.some(
      (step) =>
        hasAnswer(step) &&
        (!isTauri() || rendersInCurrentWindow(presentation, step)),
    )
  )
    return;
  usePresentationCompletionStore
    .getState()
    .markCompleted(presentation.executionId);
}
